import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textCutter',
    standalone: false
})
export class TextCutterFormater implements PipeTransform {

  transform(text: any, maxLength: number): any {
    if(maxLength && text.length > maxLength){
        return text.substr(0, maxLength) + "..."
    }else{
        return text;
    }
  }
}


